module.exports = __webpack_public_path__ + "img/check_box_white_24dp.b41c90ee.svg";